import classNames from "classnames";
import { EOSNode } from "../../build/types";
import { useInteractionStates } from "../../hooks/useInteractionStates";
import { EOSComponentProps } from "../BuilderInterface";
import EOSLayout from "../PrintLayouts/EOS";
import { getCompoundStyle, getStateStyleForBuilder, getStylesFromInteractiveStates } from "../helpers";
import "./style.scss";

const BuilderEOS: React.FC<EOSComponentProps> = ({
    node,
    eosData,
    builderProps,
    formatCurrency,
    additionalProps
}: EOSComponentProps) => {
    const eosNode = node as EOSNode;
    const { attr, id, stateManager } = eosNode;
    const { setElement, states } = useInteractionStates<HTMLDivElement>();

    const EOSClassName = classNames("eos-builder-wrapper", {
        [`${attr?.className}`]: !!attr?.className
    });

    if (builderProps) {
        const { nodeState, selectCallback, outlineCallback, onDragStart, onDragEnd } = builderProps;

        return (
            <div
                {...attr}
                className={EOSClassName}
                style={getCompoundStyle({
                    node,
                    stateStyle: getStateStyleForBuilder(stateManager, nodeState, "attr_style")
                })}
                onClick={e => (selectCallback ? selectCallback(e, id) : {})}
                onMouseMove={e => (outlineCallback ? outlineCallback(e, id) : {})}
                id={id}
                onDragStart={e => onDragStart?.(e, id)}
                draggable={"true"}
                onDragEnd={onDragEnd}
            >
                <div id="print">
                    <EOSLayout
                        additionalProps={additionalProps}
                        node={eosNode}
                        eosData={eosData}
                        formatCurrency={formatCurrency ? formatCurrency : (amount: number) => amount.toFixed(2)}
                    />
                    {builderProps.selectedMenu}
                </div>
            </div>
        );
    } else {
        const eosStyle = getStylesFromInteractiveStates({
            states,
            defaultStyle: getCompoundStyle({ node }),
            stateManager,
            paths: ["attr_style"]
        });

        return (
            <div ref={setElement} {...attr} className={EOSClassName} style={eosStyle}>
                <div id="print">
                    <EOSLayout
                        node={eosNode}
                        eosData={eosData}
                        formatCurrency={formatCurrency ? formatCurrency : (amount: number) => amount.toFixed(2)}
                    />
                </div>
            </div>
        );
    }
};

export default BuilderEOS;
